import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2Icon } from 'lucide-react';
export function FreeTireChecksPage() {
  return <div data-id="element-1096">
      {/* Page Header */}
      <div className="bg-[#000000] py-14 px-4 sm:px-6 lg:px-8 text-center" data-id="element-1097">
        <p className="text-[#822433] font-bold text-sm uppercase tracking-widest mb-3" data-id="element-1098">
          Our Services
        </p>
        <h1 className="text-4xl sm:text-5xl font-black text-white" data-id="element-1099">
          🔍 Free Tire Checks
        </h1>
        <p className="text-gray-400 text-base mt-4 max-w-xl mx-auto" data-id="element-1100">
          A free, no-obligation inspection of your tires' tread, pressure, and
          overall condition.
        </p>
      </div>

      {/* Main Content */}
      <section className="w-full bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-1101">
        <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-1102">
          <div data-id="element-1103">
            <h2 className="text-2xl sm:text-3xl font-black text-black mb-5" data-id="element-1104">
              Know Your Tires' Health — For Free
            </h2>
            <p className="text-gray-600 leading-relaxed mb-5" data-id="element-1105">
              Most drivers don't know the condition of their tires until
              something goes wrong. Our free tire check takes just 10–15 minutes
              and gives you a complete picture of your tire health — tread
              depth, inflation, visible damage, and more.
            </p>
            <p className="text-gray-600 leading-relaxed" data-id="element-1106">
              No appointment needed. Just drive in to any of our 3 locations and
              one of our technicians will inspect all four tires and give you an
              honest, no-pressure report. We believe in transparency — we'll
              only recommend service if you actually need it.
            </p>
          </div>

          {/* What's Included */}
          <div className="bg-[#F5F5F5] rounded-lg p-8" data-id="element-1107">
            <h3 className="font-black text-black text-xl mb-6" data-id="element-1108">
              What's Included
            </h3>
            <ul className="space-y-4" data-id="element-1109">
              <li className="flex items-start gap-3" data-id="element-1110">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1111" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1112">
                  Tread depth measurement on all 4 tires
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1113">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1114" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1115">
                  Tire pressure check and inflation to correct PSI
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1116">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1117" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1118">
                  Visual inspection for cuts, bulges, and sidewall damage
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1119">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1120" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1121">
                  Wear pattern analysis to detect alignment issues
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1122">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1123" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1124">
                  TPMS warning light diagnosis
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1125">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1126" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1127">
                  Honest written report — 100% free, no obligation
                </span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Why It Matters */}
      <section className="w-full bg-[#F5F5F5] py-16 px-4 sm:px-6 lg:px-8" data-id="element-1128">
        <div className="max-w-5xl mx-auto" data-id="element-1129">
          <h2 className="text-2xl sm:text-3xl font-black text-black mb-6 text-center" data-id="element-1130">
            Why Regular Tire Checks Matter
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1131">
            <div className="bg-white rounded-lg shadow-[0_2px_12px_rgba(0,0,0,0.08)] p-6" data-id="element-1132">
              <div className="text-3xl mb-3" style={{
              background: '#CC0000'
            }} onMouseEnter={e => e.currentTarget.style.background = '#AA0000'} onMouseLeave={e => e.currentTarget.style.background = '#CC0000'} data-id="element-1133">
                🛡️
              </div>
              <h3 className="font-black text-black text-base mb-2" data-id="element-1134">
                Prevent Blowouts
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-1135">
                Catching low tread or sidewall damage early prevents dangerous
                blowouts at highway speeds.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-[0_2px_12px_rgba(0,0,0,0.08)] p-6" data-id="element-1136">
              <div className="text-3xl mb-3" data-id="element-1137">⛽</div>
              <h3 className="font-black text-black text-base mb-2" data-id="element-1138">
                Save on Gas
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-1139">
                Under-inflated tires increase rolling resistance, reducing fuel
                efficiency by up to 3%.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-[0_2px_12px_rgba(0,0,0,0.08)] p-6" data-id="element-1140">
              <div className="text-3xl mb-3" data-id="element-1141">💵</div>
              <h3 className="font-black text-black text-base mb-2" data-id="element-1142">
                Save Money
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-1143">
                Identifying issues early means smaller, cheaper fixes before
                they become major problems.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Strip */}
      <section className="w-full bg-[#000000] py-14 px-4 sm:px-6 lg:px-8 text-center" data-id="element-1144">
        <h2 className="text-2xl sm:text-3xl font-black text-white mb-3" data-id="element-1145">
          Drive In for Your Free Check Today
        </h2>
        <p className="text-gray-400 text-base mb-8 max-w-lg mx-auto" data-id="element-1146">
          No appointment needed. All 3 locations open 24 hours — just pull in
          anytime.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1147">
          <Link to="/locations" className="inline-flex items-center justify-center bg-[#822433] hover:bg-[#6B1D29] text-white font-bold text-base px-8 py-4 rounded transition-colors duration-200" data-id="element-1148">
            Find a Location
          </Link>
          <Link to="/services" className="inline-flex items-center justify-center border-2 border-white text-white hover:bg-white hover:text-black font-bold text-base px-8 py-4 rounded transition-colors duration-200" data-id="element-1149">
            View All Services
          </Link>
        </div>
      </section>
    </div>;
}